// A tall beech: a long smooth silver-grey trunk under one big rounded dome of
// dense foliage with a couple of side blobs. Taller and rounder than the oak.
// Ported 1:1 from age-of-mcp's classic tree-beech.ts.
import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

function partsFor(): Part[] {
  return [
    { geometry: new THREE.CylinderGeometry(0.07, 0.11, 0.95, 6),
      color: "#8a8170", position: [0, 0.47, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.62, 0),
      color: "#4f8f3e", position: [0, 1.35, 0] },
    { geometry: new THREE.IcosahedronGeometry(0.4, 0),
      color: "#5aa047", position: [-0.34, 1.12, 0.12] },
    { geometry: new THREE.IcosahedronGeometry(0.36, 0),
      color: "#43803a", position: [0.32, 1.18, -0.14] },
    { geometry: new THREE.IcosahedronGeometry(0.3, 0),
      color: "#67b052", position: [0.05, 1.72, 0.1] },
  ];
}

export const treeBeech = defineModel({
  id: "tree-beech",
  batchId: "standard",
  name: "Tree beech",
  tags: ["scenery","tree","beech","low-poly","age-of-mcp","classic"],
  summary: "Low-poly tree beech.",
  description: "Ported from the age-of-mcp gallery.",
  author: "age-of-mcp",
  footprint: 0.6,
  parts: () => partsFor(),
  animations: [],
});
